import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BooleanComponent } from './boolean.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BooleanComponent],
  exports: [BooleanComponent]
})
export class BooleanModule {}
